import "./AboutUs.module.css";
import Navigation from "@/reusable_sections/Header";
import Standard from "./sections/Standard";
import Manufacturing from "./sections/Manufacturing";
import Certifications from "./sections/Certifications";
import Footer from "@/reusable_sections/Footer";
export default function AboutUsPage() {
  return <div>
      <Navigation />
      <Standard />
      <Manufacturing />
      <Certifications />
      <Footer />
    </div>;
}